<ngx-extended-pdf-viewer
  backgroundColor="#f4f7fa"
  useBrowserLocale="true"
  width="650px"
  height="90vh"
  [src]="data"
>
</ngx-extended-pdf-viewer>
